import { types } from 'mobx-state-tree';

import { CurrentUser } from '../../models/models';

export const CurrentUserSelected = types
  .model({
    currentUser: types.maybeNull(
      types.model({
        inspectorId: types.maybeNull(types.number),
        name: types.string,
        userId: types.number,
        clerkId: types.maybeNull(types.number),
      }),
    ),
    workPackageId: types.number,
    inspectionId: types.number,
    taskId: types.number,
    isAdhoc: types.boolean,
    assetId: types.number,
  })
  .actions(self => ({
    setCurrentUser: (currentUser: CurrentUser) => (self.currentUser = currentUser),
    setWorkPackageId: (id: number) => (self.workPackageId = id),
    setInspectionId: (id: number) => (self.inspectionId = id),
    setTaskId: (id: number) => (self.taskId = id),
    setIsAdhoc: (flag: boolean) => (self.isAdhoc = flag),
    setAssetId: (id: number) => (self.assetId = id),
  }));

export default CurrentUserSelected;
